import React, { useEffect } from "react";
import click from "../../click";
import classNames from "../classNames";
import printComponent from "../../printComponent";
import Modal from "../Modal";

const defaultProps = {
  height: "100%",
  minHeight: "12rem",
};

function InputImage({
  className,
  value,
  onChange,
  saveImage,
  print,
  height,
  placeholder,
  disabled,
  minHeight,
  setUploading,
}) {
  const [progress, setProgress] = React.useState(0);
  const [image, setImage] = React.useState(null);
  const [viewImage, setViewImage] = React.useState(false);

  const printRef = React.useRef();

  function readImage(file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImage(e.target.result);
    };
    reader.readAsDataURL(file);
  }

  function isUploading(progress) {
    if (typeof setUploading === "function") {
      return setUploading(progress);
    }
    return null;
  }

  useEffect(() => {
    isUploading(progress);
  }, [progress]);

  function onFileSelected(file) {
    readImage(file);
    const options = {
      progress: (value) => setProgress(value * 100),
    };
    saveImage
      .execute(file, options)
      .then((result) => {
        setImage(result.url);
        setProgress(0);
        onChange(result.url);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  function onClick() {
    if (disabled) return;
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".png, .jpg, .jpeg";
    input.onchange = (e) => {
      const [file] = e.target.files;
      file && onFileSelected(file);
    };
    click(input);
  }

  function onClickIcon(e) {
    e.stopPropagation();
    printComponent(printRef.current, "image")
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        alert(error);
      });
  }

  function onRemoveImage(e) {
    e.stopPropagation();
    setImage(null);
    onChange("");
  }

  function toggleOnView() {
    setViewImage((prevState) => !prevState);
  }

  return (
    <>
      <div className={classNames("align-self-stretch", className)}>
        <div className="d-none">
          <div ref={printRef} className="p-5 text-center">
            {value && <img src={value} alt="Image" className="img-fluid" />}
          </div>
        </div>{" "}
        <div className="h-100">
          <div
            className="position-relative rounded-2 overflow-hidden cursor-pointer border border-primary-subtle shadow-sm"
            style={{ height, minHeight }}
          >
            <div onClick={onClick}>
              <div className="position-absolute h-100 w-100 bg-primary bg-opacity-10" />

              {/* Image */}
              <div className="position-absolute h-100 w-100 d-flex align-items-center justify-content-center">
                {(image || value) && (
                  <img
                    src={image || value}
                    alt="Preview"
                    className="w-100 h-100 object-fit-cover"
                  />
                )}
              </div>

              <div className="position-absolute h-100 w-100 bg-gradient opacity-25" />

              {/* Placeholder */}
              {!(image || value) && (
                <div className="position-absolute h-100 w-100 d-flex flex-column align-items-center justify-content-center text-primary">
                  <div
                    className="rounded-circle bg-primary bg-opacity-25 p-4 d-flex justify-content-center align-items-center"
                    style={{ width: "4rem", height: "4rem" }}
                  >
                    <i className="bi bi-cloud-arrow-up fs-3 text-primary" />
                  </div>
                  <div className="fw-semibold" style={{ fontSize: "0.9rem" }}>
                    {placeholder || "Upload Image"}
                  </div>
                  <small className="text-muted" style={{ fontSize: "0.8rem" }}>
                    PNG, JPG up to 5MB
                  </small>
                </div>
              )}

              {progress > 0 && (
                <div className="position-absolute h-100 w-100 bg-primary bg-opacity-75 d-flex flex-column align-items-center justify-content-center">
                  <div className="spinner-border text-light mb-2" />
                  <h5 className="text-white fw-semibold mb-0">
                    Uploading {progress.toFixed(0)}%
                  </h5>
                </div>
              )}

              {print && (
                <div className="position-absolute top-0 end-0 p-2">
                  <button
                    type="button"
                    onClick={onClickIcon}
                    className="btn btn-sm btn-primary shadow"
                    disabled={disabled}
                  >
                    <i className="bi bi-printer" />
                  </button>
                </div>
              )}

              <div className="position-absolute bottom-0 w-100 text-center pb-2">
                <span className="badge bg-primary bg-opacity-75">
                  {`Click to ${image || value ? "change" : "upload"} image`}
                </span>
              </div>
            </div>

            {(image || value) && (
              <div className="d-flex gap-2 position-absolute top-0 start-0 p-2">
                <button
                  type="button"
                  onClick={onRemoveImage}
                  className="btn btn-sm btn-danger shadow"
                  disabled={disabled}
                >
                  <i className="bi bi-trash" />
                </button>

                <button
                  type="button"
                  onClick={toggleOnView}
                  className="btn btn-sm shadow"
                  style={{ backgroundColor: "#739ff4" }}
                >
                  <i className="bi bi-eye text-dark" />
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Previewing Image Modal*/}
      <Modal
        isOpen={viewImage}
        size="lg"
        closable={true}
        style={{ maxHeight: "400px" }}
      >
        <div className="position-relative">
          {image || value ? (
            <img src={image || value} width={"100%"} height={"100%"} />
          ) : (
            <div className="d-flex justify-content-center align-items-center">
              <p className="m-0 fw-bold text-muted">No image found</p>
            </div>
          )}

          <p
            className="btn btn-dark btn-md text-white fw-bold bg-danger position-absolute shadow-sm"
            style={{ top: "1rem", right: "1rem" }}
            onClick={toggleOnView}
          >
            X
          </p>
        </div>
      </Modal>
    </>
  );
}

InputImage.defaultProps = defaultProps;
export default InputImage;
